import { useDispatch } from 'react-redux';
import { updateLevelRankingRiderInput } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice';
import { formatAmountType } from '../../../../../../utils/format-numbers.utils';
import { updateSalaryRankRiderResult } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice';
import { PROPOSAL_RIDERS } from '../../../../../../constant/gms-constant';
import CheckboxRiderGDR from './checkbox-rider-GDR';
import { CheckedGreen } from '../../../../../../assets/icon/svg';
import { SelectedRider } from '../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.state';
import Input from '../../../../../ui/input';
import { customStyle, defaultStyle } from '../../../../../../constant/custom-style';
import { LevelRankingRider } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.state';
import { SalaryRankRider } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.state';

interface Props {
    riderLabel?: string;
    rider: SelectedRider;
    isPreview?: boolean;
    selectLevelRankingRidersState: LevelRankingRider[] | undefined
    selectSalaryRankRidersState: SalaryRankRider[]
    isLevelRanking: boolean;
    isSalaryRank: boolean;
}

export default function AttachableRiderInputLevelRankingBySalaryRank({ isLevelRanking, isSalaryRank, selectLevelRankingRidersState, selectSalaryRankRidersState, rider, isPreview }: Props) {

    const dispatch = useDispatch();
    const riderPlaceholder: Record<number, string> = {
        8: "Enter an amount between 100 and 300",
        9: "Enter an amount (minimum 500)",
        14: "Enter an amount (minimum 500)"
    };

    const riderSubtitle: Record<number, string> = {
        8: "Enter an amount between 100 and 200.",
        9: "Enter an amount of 500 or higher.",
        14: "Enter an amount of 500 or higher.",
        13: "Select either 1 or 2 unit.",
        16: "Enter only 10,000, 20,000, or 30,000.",
        19: "Enter only 10,000, 20,000, or 30,000.",
    };
    
    const levelRankRider = selectLevelRankingRidersState?.find(r => r.id === rider.id);
    const salaryRankRider = selectSalaryRankRidersState?.find(r => r.id === rider.id);

    const inputClassName = isPreview
        ? "w-full rounded-lg border border-gray-200 bg-gray-100 px-3 py-2 text-xs text-gray-500 outline-none cursor-not-allowed"
        : "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-gray-800 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100";

    return (
        <tr className="group transition-colors hover:bg-blue-50/30">
            <td className="sticky left-0 z-30 min-w-[160px] lg:min-w-[300px] border-b border-gray-200 bg-white px-4 py-3 shadow-[4px_0_10px_rgba(0,0,0,0.03)] group-hover:bg-blue-50">
                <div className="flex min-w-0 items-start gap-2">
                    {isPreview && (
                        <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-500 text-white">
                            <CheckedGreen />
                        </div>
                    )}
                    <div className="flex min-w-0 flex-col gap-1">
                        <span className="break-words font-medium text-gray-800">
                            {rider.label}
                        </span>
                        {!isPreview && riderSubtitle[rider.id] && (
                            <span className="text-[10px] leading-4 text-gray-500">
                                {riderSubtitle[rider.id]}
                            </span>
                        )}
                    </div>
                </div>
            </td>
            {isLevelRanking && levelRankRider?.inputs.map((input, index) => (
                <td key={index} className="min-w-[150px] border-b border-l border-gray-200 px-2 py-1">
                    {!isPreview && Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => id === rider.id) ? (
                        <div className="flex min-h-[36px] w-full items-center justify-center">
                            <CheckboxRiderGDR
                                amount={input.fAmount}
                                isPreview={isPreview}
                                rider_id={rider.id}
                                onChange={(value) => {
                                    dispatch(updateLevelRankingRiderInput({
                                        riderId: rider.id,
                                        inputIndex: index,
                                        fAmount: value
                                    }));
                                }}
                            />
                        </div>
                    ) : (
                        <Input 
                            type="text" 
                            value={formatAmountType(input.fAmount)} 
                            readonly={isPreview} 
                            disabled={isPreview} 
                            placeholder={riderPlaceholder[rider.id] ?? "Enter amount"} 
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${(input.fAmount === 0 || !input.fAmount) ? '' : customStyle }`}
                            onChange={(e) => {
                                if (isPreview) return;
                                const rawValue = e.target.value.replace(/,/g, '');
                                const newFAmount = Number(rawValue) || 0;
                                dispatch(updateLevelRankingRiderInput({
                                    riderId: rider.id,
                                    inputIndex: index,
                                    fAmount: newFAmount
                                }));
                            }} 
                        />
                    )}
                </td>
            ))}
            {isSalaryRank && salaryRankRider?.rider?.map((input, index) => (
                <td key={input.id ?? index} className="min-w-[150px] border-b border-l border-gray-200 px-2 py-2">
                    {Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => id === rider.id) ? (
                        <div className="flex min-h-[36px] items-center justify-center">
                            <CheckboxRiderGDR amount={input.result} isPreview={isPreview} rider_id={rider.id} onChange={(value) => {
                                dispatch(updateSalaryRankRiderResult({
                                    riderId: rider.id,
                                    id: input.id ?? "",
                                    result: value
                                }));
                            }} />
                        </div>
                    ) : (
                        <Input 
                            type="text" 
                            value={formatAmountType(input.result)} 
                            readonly={isPreview} 
                            disabled={isPreview} 
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${(input.result === 0 || !input.result) ? '' : customStyle }`}
                            onChange={(e) => {
                            if (isPreview) return;
                                const rawValue = e.target.value.replace(/,/g, '');
                                const newSalary = Number(rawValue) || 0;
                                dispatch(updateSalaryRankRiderResult({
                                    riderId: rider.id,
                                    id: input.id ?? "",
                                    result: newSalary
                                }));
                            }} 
                        />
                    )}
                </td>
            ))}
        </tr>
    );
}